<template>
  <div class="toast-container">
    <div 
      v-for="toast in toasts" 
      :key="toast.id" 
      class="toast" 
      :class="`toast--${toast.type}`"
    >
      <div class="toast__content">{{ toast.message }}</div>
      <button class="toast__close" @click="removeToast(toast.id)">×</button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const toasts = ref([])

const addToast = (message, type = 'error') => {
  const id = Date.now()
  toasts.value.push({ id, message, type })
  // No setTimeout - infinite lifetime, manual close only
}

const removeToast = (id) => {
  toasts.value = toasts.value.filter(toast => toast.id !== id)
}

defineExpose({ addToast })
</script>

<style lang="sass">
.toast-container
  position: fixed
  top: 20px
  right: 20px
  z-index: 1000
  display: flex
  flex-direction: column
  gap: 10px

.toast
  min-width: 300px
  max-width: 500px
  padding: 15px
  border-radius: 5px
  display: flex
  align-items: center
  justify-content: space-between
  animation: slideIn 0.3s ease-out
  box-shadow: 0 4px 12px rgba(0,0,0,0.15)
  font-weight: 600

  &--error
    background: colors.$red
    color: white

  &--success  
    background: colors.$realgreen
    color: white

  &--warning
    background: colors.$yellow
    color: colors.$dark

  &__content
    flex: 1
    margin-right: 10px

  &__close
    background: none
    border: none
    color: inherit
    font-size: 20px
    cursor: pointer
    padding: 0
    width: 24px
    height: 24px
    display: flex
    align-items: center
    justify-content: center
    border-radius: 50%
    
    &:hover
      background: rgba(255,255,255,0.2)

@keyframes slideIn
  from
    transform: translateX(100%)
    opacity: 0
  to
    transform: translateX(0)
    opacity: 1
</style>